import { useMemo, useSyncExternalStore } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getToken, subscribeToken } from '../pages/interactive/utils/token';
import { createPersonalMqttAdapter } from '../services/mqtt/personalAdapter';
import type { MqttAclAdapter } from '../services/mqtt/aclSession';
import { resolveMqttMode } from '../services/mqtt/mqttConfig';

let sessionRevision = 0;
const noToken = () => null;

export function usePersonalMqttAdapter(enabled = true): MqttAclAdapter | undefined {
  // These helpers are used by login, refresh and logout; no site/guest token is read.
  const token = useSyncExternalStore(subscribeToken, getToken, noToken);
  const revision = useMemo(() => String(++sessionRevision), [token]);
  const apiUrl = process.env.REACT_APP_MQTT_API_URL || process.env.REACT_APP_SERVER_URL || '';
  const brokerUrl = process.env.REACT_APP_MQTT_ACL_URL || 'wss://mqtt-broker.scfg.io/mqtt';
  const query: { data?: MqttAclAdapter } = useQuery({
    queryKey: ['mqtt-personal-adapter', revision, apiUrl, brokerUrl],
    enabled: enabled && resolveMqttMode() === 'acl' && !!token && !!apiUrl,
    queryFn: ({ signal }: { signal: AbortSignal }) => createPersonalMqttAdapter({
      token: token!, apiUrl, brokerUrl, revision, isCurrent: () => getToken() === token
    }, signal),
    retry: false,
    gcTime: 0
  });
  return enabled && token && resolveMqttMode() === 'acl' ? query.data : undefined;
}
